import Modal from '../classes/modal';

export default class HtmlModal {

    /**
     * Initializes all modals
     */
    static init() {
        return new HtmlModal();
    }

    constructor() {
        const modalTriggers = document.querySelectorAll('[data-show-modal]');
        modalTriggers.forEach((element) => {
            element.addEventListener('click', function (event) {
                event.preventDefault();
                const modalElement = element.querySelector('[data-modal]');
                if (modalElement) {
                    let modal = new Modal().with(modalElement);
                    modal.show();
                }
            });
        });

        window.showModal = function (triggerElement) {
            const modalElement = triggerElement.querySelector('[data-modal]');
            new Modal().with(modalElement).show();
        }
    }
}